import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';
import {
  calendarIntegrationsQueryKey,
  disconnectCalendarConnection,
  getCalendarIntegrations,
  startCalendarConnect,
} from '../api/calendar-integrations.client.js';

export function useCalendarIntegrations() {
  const scope = useCurrentScope();
  return useQuery({
    queryKey: calendarIntegrationsQueryKey(scope?.workspaceId ?? 'anonymous'),
    queryFn: getCalendarIntegrations,
    enabled: scope !== null,
  });
}

export function useCalendarIntegrationMutations() {
  const scope = useCurrentScope();
  const client = useQueryClient();
  const queryKey = calendarIntegrationsQueryKey(scope?.workspaceId ?? 'anonymous');
  return {
    // gcTime: 0 — результат нужен ровно один раз: сразу уводим браузер на authorize-URL.
    connect: useMutation({ mutationFn: startCalendarConnect, gcTime: 0 }),
    disconnect: useMutation({
      mutationFn: disconnectCalendarConnection,
      onSuccess: async () => {
        await client.invalidateQueries({ queryKey });
      },
    }),
  };
}
